import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {fullName} from 'shared/tools';

class ExternalCandidate extends DomainObject {
  id;
  firstName;
  lastName;
  email;
  avatarInitials;
  avatarColour;
  jobTitle;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      firstName: observable,
      lastName: observable,
      email: observable,
      avatarInitials: observable,
      avatarColour: observable,
      jobTitle: observable,
      name: computed
    });

    this.merge(other);
  }

  get name() {
    return fullName(this);
  }
}

export default ExternalCandidate;
